import { PartyModel } from "./types";

export default function SortPartyGroupsByDate(groups: PartyModel[]): PartyModel[] {

    const sortedGroups = groups.sort((a, b) => new Date(a.party.partyDate).getTime() - new Date(b.party.partyDate).getTime());

    return sortedGroups;
}